export const messages = {
  en: {
    shopWithdraw: {
      confirmOperation: 'Please confirm your operation',
      withdrawReason: 'Withdrawal Reason',
      requiredRemark: 'Required, please fill in withdrawal comments',
      cancel: 'Cancel',
      confirmWithdraw: 'Confirm Withdrawal',
      processSuccess: 'Processed successfully',
      processFailed: 'Processing failed: '
    }
  },
  zh: {
    shopWithdraw: {
      confirmOperation: '请确认您的操作',
      withdrawReason: '撤回说明',
      requiredRemark: '必填，请填写撤回意见',
      cancel: '点错了',
      confirmWithdraw: '确认撤回',
      processSuccess: '处理成功',
      processFailed: '处理失败：'
    }
  }
}